<template>
  <h4
    v-bind="attributesBinding"
    class="text-center pa-1"
    :class="{
      'rounded-circle': currentField.isType == 'CIRCLE',
      'pa-1':
        currentField.isType == 'CIRCLE' ||
        currentField.isType == 'ROUND_SQUARE',
      rounded: currentField.isType == 'ROUND_SQUARE',
    }"
  >
    {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
  </h4>
</template>


<script>
export default {
  name: "FormElementTitle",
  store: ["mainExpression"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      const { currentField } = this;
      var attr = {};
      console.log("currentField: ", currentField);
      if (currentField.id) {
        attr.id = `FormElementTitle-${currentField.id}`;
      }
      if (currentField.color) {
        attr.style = {
          color: currentField.isType == "TEXT" ? currentField.color : "white",
          ...attr.style,
        };
      }
      if (currentField.isType != "TEXT") {
        attr.style = {
          "background-color": currentField.color,
          padding: "0 4px",
          ...attr.style,
        };
      }
      console.log("attr.style: ", attr.style);
      return attr;
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
h4 {
  user-select: none;
}
</style>
